import { render, staticRenderFns } from "./KiddiesOnboardingModal.vue?vue&type=template&id=7028200a&scoped=true"
import script from "./KiddiesOnboardingModal.vue?vue&type=script&lang=js"
export * from "./KiddiesOnboardingModal.vue?vue&type=script&lang=js"
import style0 from "./KiddiesOnboardingModal.vue?vue&type=style&index=0&id=7028200a&prod&scoped=true&lang=css"
import style1 from "./KiddiesOnboardingModal.vue?vue&type=style&index=1&id=7028200a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7028200a",
  null
  
)

export default component.exports